// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"240":"c36f3faa","501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"240":"329e839aedd7089b","501":"ce27a1ccae3b3211","3756":"b5fa977db7bbf549","4316":"da7517a88118b074","6735":"a3eb23c166e5ee5a","7970":"24ac5654e6016ab1","9839":"0002ff4090fcfbe7"}[chunkId] + ".js";
};